<template>
  <va-card title="Image analysis resualts">

  <div class="row align--center">
    <va-input-wrapper :messages="[]">
      <div class="flex xs12 md6">
        <va-input
        v-model="term"
        :placeholder="$t('Search by reference ID')"
        >
        <va-icon name="fa fa-search" slot="prepend" />
        <va-button  small color="info" :disabled="term.length <= 0" @click="search" slot="append">
          {{ $t('Find') }}
        </va-button>
        <va-button  small color="warning" v-if="term.length >= 1"  @click="clear" slot="append">
          {{ $t('Clear') }}
        </va-button>
        </va-input>
      </div>

    </va-input-wrapper>
  </div>

  <va-data-table
    :fields="fields"
    :data="data"
    :loading="loading"
    :totalPages="totalPages"
    @page-selected="request"
    api-mode
  >

  <template slot="referance_resource" slot-scope="props">
    <img :src="props.rowData.referance_resource" class="data-table-server-pagination---avatar">
  </template>

  <template slot="actions" slot-scope="props">
   
    <!-- <va-button  small color="success" class="">
      {{ $t('Reprocess') }}
    </va-button> -->

    <va-button :to="{ name: 'ImageAnalystResultsSingle', params: { id: props.rowData.id }}" small color="info" class="">
      {{ $t('View') }}
    </va-button>

  </template>

</va-data-table>
</va-card>
</template>
<script>
  import Table from '../../ui/table/Table';
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
  import { debounce } from 'lodash'
  export default {
    components: {
      Table,
    },
    props: [],
    data () {
      return {
        paginate: 10,
        totalPages: 0,
        loading: false,
        term:''
      }
    },
    computed: {

      fields () {
        return [
        {
          name: '__slot:referance_resource',
          title: 'Media reference:',
        },{
          name: 'referance_id',
          title: 'Reference ID:',
        },
        {
          name: 'referance_type',
          title: 'Reference type:',
        },
        {
          name: 'created_at',
          title: 'Analysed at:',
        },
        {
          name: 'task_id',
          title: 'Job ID:',
        },{
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
      },

      ...mapState({
        data: state => state.imageAnalyst.long_term_results,
      })
      
    },
    methods: {

      ...mapActions({
        fetch: 'fetchLongTermResults'
      }),

      /**
       * search to inr request 
       * @return void
       */
      search(){
        this.request()
      },

      /**
       * celar to remove params
       * @return void
       */
      clear(){
        this.term = ""
        this.request()
      },


      /**
       * Request list of resources
       * @return void
       */
      request(page = 1){

        this.loading  = true
        let params    = { page: page, paginate:this.paginate,term:this.term }

        this.fetch(params).then( response => { 

          this.loading = false 
          this.totalPages = response.pages
        })

      }

    },
    mounted(){
      this.request()
    }
  }
</script>
<style lang="scss" scoped>

.data-table-server-pagination---avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transform: scale(1.4);
}

</style>
